import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const InProgress = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path
      d="M5.6,16.8c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.2,0-0.3,0.1c-0.2,0.2-0.3,0.5-0.1,0.7C5,17.7,5.3,18,5.5,18.2
	c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2,0,0.3-0.1c0.2-0.2,0.2-0.5,0-0.7C6,17.3,5.8,17.1,5.6,16.8z M7.3,4.4C7.1,4.4,7.1,4.5,7,4.7
	C7,4.8,7,4.9,7.1,5c0.1,0.2,0.5,0.3,0.7,0.2C8,5.1,8.1,5,8.3,4.9C9.4,4.3,10.7,4,12,4c4.4,0,8,3.6,8,8c0,3-1.7,5.6-4.1,7
	c-0.2,0.1-0.5,0.3-0.7,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c0,0.1,0,0.2,0,0.3c0.1,0.3,0.4,0.4,0.7,0.3c0.2-0.1,0.7-0.4,0.9-0.5
	c2.7-1.6,4.4-4.4,4.4-7.7c0-5-4-9-9-9c-1.4,0-2.6,0.3-3.8,0.8c0,0-0.3,0.1-0.5,0.2C7.5,4.2,7.3,4.4,7.3,4.4z M17.6,13
	c0.2,0,0.4-0.2,0.4-0.4v-0.1c0-0.2-0.2-0.4-0.4-0.4H12V7.5C12,7.2,11.8,7,11.5,7S11,7.2,11,7.5v5.1c0,0.2,0.2,0.4,0.4,0.4H17.6z
	 M9.2,19.5c-0.3-0.1-0.5-0.2-0.8-0.4C8.2,19,8,19,7.9,19.1c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0.2,0,0.5,0.2,0.7c0.3,0.2,0.6,0.3,0.9,0.4
	c0.1,0.1,0.3,0,0.4,0c0.1-0.1,0.2-0.1,0.3-0.3C9.5,19.9,9.4,19.6,9.2,19.5z M12.6,20c-0.3,0-0.6,0-0.9,0c-0.2,0-0.3,0.1-0.4,0.2
	c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.7,0,1,0c0.1,0,0.3-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.1-0.4
	C13.2,20.2,12.9,20,12.6,20z M4.2,13.6c0-0.2-0.1-0.3-0.3-0.3c-0.1,0-0.2-0.1-0.3,0c-0.3,0.1-0.4,0.3-0.4,0.6c0.1,0.3,0.2,0.6,0.3,1
	c0,0.1,0.1,0.2,0.3,0.3c0.1,0.1,0.2,0.1,0.4,0c0.3-0.1,0.4-0.4,0.3-0.6C4.3,14.2,4.2,13.9,4.2,13.6z M4.1,11c0-0.3,0.1-0.6,0.2-0.9
	c0-0.2,0-0.3-0.1-0.4C4.1,9.6,4,9.5,3.9,9.5C3.6,9.4,3.3,9.6,3.3,9.9c-0.1,0.3-0.1,0.7-0.2,1c0,0.1,0,0.3,0.1,0.4
	c0.1,0.1,0.2,0.2,0.3,0.2C3.8,11.5,4,11.3,4.1,11z M5.3,7.7C5.4,7.4,5.6,7.2,5.8,7c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1-0.1-0.2-0.2-0.3
	C5.5,6.1,5.2,6.1,5,6.3C4.8,6.6,4.6,6.9,4.4,7.1C4.3,7.3,4.3,7.4,4.4,7.5c0,0.1,0.1,0.2,0.2,0.3C4.8,8,5.1,7.9,5.3,7.7z"
    />
  </SvgIcon>
);

export default InProgress;
